const getters = {
    parkingList: state => state.parking.parkingList,
    token: state => state.user.token,
};
export default getters;
